import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'default',
  padding: 'default',
  marginTop: 'looser',
  backgroundColor: 'bg.softest',
  borderRadius: 'md',
});

export const textContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const messageText = css({
  fontSize: 'body-sm',
  fontWeight: 'regular',
  color: 'text.neutral',
});

export const exploreLink = css({
  fontSize: 'body-sm',
  fontWeight: 'regular',
  color: 'brand.primary',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  textAlign: 'left',
  textDecoration: 'underline',
  _hover: {
    color: 'brand.primaryHover',
  },
});
